import Vue from "vue";

import websocket from "@/utils/websocket/index";
export const people = {
  methods: {
    //获取房间列表
    async getPeopleList() {
        let res = await this.$http.get("/tenant/emergency/room/list");
        return res;
    },
    //离开房间
    async leaveRoomPost(roomNum) {
      let res = await this.$http.post(`/tenant/emergency/room/leave/room/${roomNum}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //选择角色
    async chooseRolePost(obj) {
      let res = await this.$http.put(`/tenant/emergency/room/to/selectRole`,obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //加入房间校验
    async checkRoomPost() {
      let res = await this.$http.post(`/tenant/emergency/room/check`);
     
      return res;
    },

    //开始演练
    async startExercisePost(roomNum) {
      let res = await this.$http.post(`/tenant/emergency/room/start/${roomNum}`);
    
      return res;
    },

    //发送消息
    async sendMessagePost(obj) {
      let res = await this.$http.post(`/tenant/emergency/room/next`,obj);
      return res;
    },

    //机器人的跳过
    async sendRoomNumMessagePost(roomNum) {
      let res = await this.$http.post(`/tenant/emergency/room/needManReply/${roomNum}`);
      return res;
    },

  },
};
